module.exports = {
  contact: {
    badge: "Contact",
    title: "Contact",
    subtitle: "Minimal contact page.",
    summaryTitle: "Connect",
    summaryText: "You can replace this page with real contacts later.",
    summaryPoints: ["Email", "Phone", "Telegram"],
    cardsTitle: "Channels",
    cardsSubtitle: "Minimal contact set.",
    cards: [
      { icon: "fas fa-envelope", title: "Email", text: "demo@smartteamdev.ru" },
      { icon: "fas fa-phone-volume", title: "Phone", text: "+7 (495) 123-45-67" },
      { icon: "fab fa-telegram-plane", title: "Telegram", text: "@smartteamdev" }
    ],
    listTitle: "Next steps",
    listSubtitle: "Simple list for future content.",
    listItems: ["Write", "Call", "Demo"],
    stats: [
      { value: "24h", label: "reply" },
      { value: "3", label: "channels" }
    ],
    ctaTitle: "Send request",
    ctaText: "Use this block for a form or CTA later.",
    primaryHref: "mailto:demo@smartteamdev.ru",
    primaryLabel: "Write",
    secondaryHref: "/pages/portal",
    secondaryLabel: "Portal",
    detailsTitle: "",
    details: [
      { icon: "fas fa-envelope", label: "", value: "", href: "mailto:" },
      { icon: "fas fa-phone-volume", label: "", value: "", href: "tel:" },
      { icon: "fab fa-telegram-plane", label: "", value: "", href: "" }
    ],
    formTitle: "",
    formText: ""
  }
};